<fieldset class="bordas" [style]="'width: auto'">
    <div>
        <div fxLayout="column" fxFlex="90%">
            <div fxLayout="row" fxLayoutGap="20px">
                <div ngModelGroup="comboMetaAcao_{{idRandomico}}" fxFlex="100">
                    <combo-meta-acao [showDisplayId]="false"
                                     [obrigatorio]="true"
                                     [selecionado]="meta.metaAcao?.metaObjetivo"
                                     (valorChange)="onValorChangeMeta($event)"
                                     [idAtividade]="idAtividade"
                                     [desabilitado]="desabilitarCampos">
                    </combo-meta-acao>
                </div>
            </div>
        </div>

        <div fxLayout="column" fxFlex="10%" fxLayoutAlign="center center">
            <button mat-icon-button (click)="deletar()" style="padding: 0px;" [disabled]="desabilitarCampos">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
    </div>
</fieldset>